<template>
  <div>
    <div class="page-main home-main">
      <div class="container">
        <el-carousel height="120px" class="home-banner-box" :interval="6000" indicator-position="none" arrow="never">
          <el-carousel-item v-for="item in home_page_main.ad_1" :key="item">
            <a :href="item.link">
              <img :src="item.image" />
            </a>
          </el-carousel-item>
        </el-carousel>

        <div v-for="(item, index) in home_page_main.goods_category" :key="index">
          <a :href="'#' + item.id">{{ item.name }}</a>
          <div v-for="(child, child_index) in item['_child']" :key="child_index">
            <div class="home-brick-box home-brick-row-2-box xm-plain-box">
              <div class="box-hd">
                <h3 class="title">
                  <a :href="'/category/child/' + child.name">{{
                    child.name
                  }}</a>
                </h3>
                <div class="more" style="width:700px;word-wrap:break-word;text-align:right">
                  <a :href="'/category/grand/' + grand.name"
                    style="padding-left:4px;padding-right:4px;cursor:pointer;word-wrap:break-word;"
                    v-for="(grand, grand_index) in child['_child']" :key="grand_index">
                    {{ grand.name }}
                  </a>
                </div>
              </div>
            </div>

            <div class="box-bd clearfix">
              <div class="box" style="" v-for="(grand, grand_index) in child['_child']" :key="grand_index">
                <a :href="'/category/grand/' + grand.name"
                  style="width:100%;height:100%;background:#fff;display:inline-block;text-align:center">
                  <div>
                    <el-image style="width: 180px; height: 200px" :src="grand.image" fit="cover" lazy></el-image>
                  </div>
                  <div style="margin-top:10px;">
                    {{ grand.name }}
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { api, session } from "@/assets/js/util.js";

export default {
  name: "HomePageMain",
  inject: ["global"],
  data() {
    return {
      metaInfo: {
        title: '默认页面标题',
        keywords: '默认页面关键词', 
        description: '默认页面描述',
      },
      home_page_main: {
        ad_1: [],
        ad_2: [],
        goods_category: [],
      },
    };
  },
  mounted() {
    this.getMetaInfo();
    this.getData();
    this.global.isShowCateLink = false;
  },
  methods: {
    getMetaInfo() {
      let that = this;
      api.post("home/meta_info").then(function (res) {
        if (res.code) {
          that.metaInfo = res.data;
          that.setPageMeta();
        }
      });
    },
    getData() {
      let that = this;
      let home_page_main = session.get("home_page_main");
      if (!home_page_main === true) {
        api.get("home_page_main").then(function (res) {
          if (res.code) {
            session.set("home_page_main", res.data);
            that.home_page_main = session.get("home_page_main");
          }
        });
      } else {
        that.home_page_main = session.get("home_page_main");
      }
    },
  },
};
</script>
<style scoped>
.box {
  display: inline-block;
  width: 234px;
  height: 300px;
  box-sizing: border-box;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 35px;
  padding-bottom: 20px;
  margin-bottom: 20px;
  background: #fff;
  margin-left: 14px;
}

.box:first-child,
.box:nth-child(6),
.box:nth-child(11),
.box:nth-child(16),
.box:nth-child(21),
.box:nth-child(26),
.box:nth-child(31),
.box:nth-child(36),
.box:nth-child(41),
.box:nth-child(46),
.box:nth-child(51),
.box:nth-child(56),
.box:nth-child(61),
.box:nth-child(66),
.box:nth-child(71),
.box:nth-child(76),
.box:nth-child(81),
.box:nth-child(86),
.box:nth-child(91),
.box:nth-child(96) {
  margin-left: 0px !important;
}

.box:hover {
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}
</style>
